import React from "react";
import { FormattedMessage } from "react-intl";
import { Row, Space } from "@masterteam/mt-design-react";

import Objective from "./Objective";

import "./style.scss";

const ObjectivesSectorsPerformance = ({
  data,
  kpiStatuses,
  projectStatuses,
}) => {
  return (
    <Space
      direction="vertical"
      className="objectives-sectors-performance"
      size="large"
      gap={30}
    >
      <Row
        size="large"
        align="center"
        justify="between"
        className="objectives-sectors-performance__header"
      >
        <div className="objectives-sectors-performance__title">
          <FormattedMessage id="dashboards.level-one-objective-performance" />
        </div>
      </Row>

      <Space direction="vertical" gap={40}>
        {data?.Objectives?.map((item) => (
          <Objective
            item={item}
            kpiStatuses={kpiStatuses}
            projectStatuses={projectStatuses}
          />
        ))}
      </Space>
    </Space>
  );
};

export default ObjectivesSectorsPerformance;
